import styled from "styled-components";
import { maxSize, px2percent, px2vw, textLineClamp } from "../../Utils/common";
import { STYLE_TYPE, themeColor } from "../../Utils/magicStrings";

export const HomeWrapper = styled('div')`
    width: 100vw;
    margin: auto;
`;

// max-width: 1440px;
export const AboutUsTextWrapper = styled('div')`
    position: absolute;
    ${props => maxSize(140, props.styleType, 'top', 302)};
    ${props => maxSize(146, props.styleType, 'right', 24)};
    ${props => maxSize(417, props.styleType, 'width', 327)};
    ${props => maxSize(106, props.styleType, 'height')};
`;

export const AboutUsMainText = styled('pre')`
    margin: 0;
    ${props => maxSize(18, props.styleType, 'font-size', 16)};
    ${props => maxSize(32, props.styleType, 'margin-top', 16)};
    ${props => maxSize(38, props.styleType, 'line-height', 32)};
    letter-spacing: 0.02em;
    color: ${props => props.isNowPage ? themeColor : '#B7B8B8'};
    font-weight: 600;
    white-space: pre-wrap;
    ${textLineClamp(1)};
`;

export const AboutUsSubText = styled('pre')`
    ${props => maxSize(12, props.styleType, 'font-size')};
    ${props => maxSize(8, props.styleType, 'padding-top', 8)};
    ${props => maxSize(32, props.styleType, 'line-height', 24)};
    color: ${props => props.isNowPage ? '#000000' : '#B7B8B8'};
    letter-spacing: 0.02em;
    overflow: hidden;
    white-space: pre-wrap;
    margin: 0;
    ${textLineClamp(2)};
`;

export const AboutUsWrapper = styled('div')`
    position: relative;
    ${props => maxSize(72, props.styleType, 'margin-top', 64)};
    ${props => maxSize(550, props.styleType, 'height', 432)};

`;

export const SwiperBackground = styled('div')`
    position: absolute;
    background-color: ${themeColor};
    ${props => maxSize(140, props.styleType, 'top', 88)};
    ${props => maxSize(174, props.styleType, 'left', 32)};
    ${props => maxSize(682, props.styleType, 'width', 319)};
    ${props => maxSize(458, props.styleType, 'height', 202)};
`;


export const SwiperWrapper = styled('div')`
    position: absolute;
    ${props => maxSize(693, props.styleType, 'width', 319)};
    ${props => maxSize(441, props.styleType, 'height', 202)};
    ${props => maxSize(140, props.styleType, 'top', 82)};
    ${props => maxSize(146, props.styleType, 'left', 24)};
    z-index: 2;
`;

export const TitleText = styled('div')`
    display: flex;
    flex-direction: column;
    align-items: center;
    ${props => maxSize(37,props.styleType, 'margin-bottom', 24)};
    & .main {
        ${props => maxSize(46, props.styleType, 'font-size', 20.625)};
        letter-spacing: ${props => props.styleType !== STYLE_TYPE.MOBILE && '0.08em'};
        ${props => {
            if(props.styleType === STYLE_TYPE.MOBILE) {
                return `
                    line-height: 8vw;
                    height: 6vw;
                `;
            }
        }}
        font-weight: 300;
    }
    & .sub {
        ${props => maxSize(24, props.styleType, 'font-size', 18)};
        letting-spacing: 0.02em;
        color: ${themeColor};
        ${props => maxSize(-0.5, props.styleType, 'margin-top', 8)};
    }
`;

export const CollectionWrapper = styled('div')`
    position: relative;
    ${props => maxSize(132, props.styleType, 'margin-top', 40)};
`;

export const CollectionSubTitle = styled('div')`
    margin-top: 63px;
    display: flex;
    margin: ${props => props.category !== 'select' ? '133px' : '63px'} 0 29px ${px2percent(146, 1440)} ;
    align-items: center;
    & div {
        background-color: ${themeColor};
        height: 2px;
        width: ${px2vw(42, 1440)};
        max-width: 42px;
    }
    & span {
        display: block;
        color: ${themeColor};
        ${props => maxSize(24, props.styleType, 'font-size')};
        ${props => maxSize(10, props.styleType, 'margin-left')};
        ${props => maxSize(10, props.styleType, 'margin-right')};
    }
    ${props => {
        if(props.styleType === STYLE_TYPE.MOBILE) {
            return `
                margin: ${px2vw(40, 375)} 0 ${px2vw(16, 375)} 0;
                width: 100vw;
                justify-content: center;
                font-size: ${px2vw(14, 375)};
            `
        }
    }}
`;

export const CardWrapper = styled('div')`
    display: ${props => props.styleType !== STYLE_TYPE.MOBILE && 'inline-block'};
    ${props => maxSize(480, props.styleType, 'width', 375)};
    ${props => maxSize(277, props.styleType, 'height', 216)};
    position: relative;
`;  

export const CardPicWrapper = styled('div')`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    & img {
        height: 100%;
        width: 100%;
    }
`;

export const TagsWrapper = styled('div')`
    position: absolute;
    ${props => maxSize(30, props.styleType, 'right', 14)};
    ${props => maxSize(23, props.styleType, 'top', 18)};
`;

export const CardTag = styled('div')`
    display: inline-block;
    color: white;
    ${props => maxSize(12, props.styleType, 'font-size', 8)};
    ${props => maxSize(26, props.styleType, 'line-height', 9)};
    ${props => maxSize('auto', props.styleType, 'width', 73)};
    ${props => maxSize(23, props.styleType, 'height', 8)};
    ${props => maxSize(5, props.styleType, 'padding', 5)};
    ${props => maxSize(8, props.styleType, 'padding-left', 8)};
    ${props => maxSize(8, props.styleType, 'padding-right', 8)};
    ${props => maxSize(28, props.styleType, 'line-height', 10)};
    text-align: center;
    border-radius: 4px;
    letter-spacing: 0.02em;
    margin-left: 4px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    ${props => {
        if(props.type === 'normal') {
            return `
                border: 1px solid white;    
            `;
        } else {
            return `
                width: auto;
                ${maxSize(155, props.styleType, 'max-width', 120)};
                border: 1px solid #B69A67;    
                background: #B69A67;
            `;
        }
    }}
`;

export const CardTextWrapper = styled('div')`
    position: absolute;
    ${props => maxSize(108, props.styleType, 'top', 79)};
    ${props => maxSize(47, props.styleType, 'left', 32)};
    & .main {
        ${props => maxSize(283, props.styleType, 'width', 287)};
        ${props => maxSize(18, props.styleType, 'font-size', 16)};
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        word-break: break-all;
        color: white;
    }
    & .sub {
        ${props => maxSize(384, props.styleType, 'width', 287)};
        ${props => maxSize(10, props.styleType, 'font-size',8)};
        ${props => maxSize(19, props.styleType, 'line-height',19)};
        margin-top: 10px;
        letter-spacing: 0.02em;
        color: white;
        ${textLineClamp(3)};
        white-space: pre-wrap;
    }
`;

export const HoverCover = styled('div')`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,0.51);
    & img {
        width: 100%;
        height: 100%;
    }
`;

export const CollectionPageWrapper = styled('div')`
    display: inline-block;
    font-size: 0;
    width: ${px2vw(1440, 1440)};
    white-space: wrap;
`;
// max-width: 1440px;

export const ExperienceWrapper = styled('div')`
    ${props => maxSize(164, props.styleType, 'margin-top', 80)};
`;

export const ExperienceCardWrapper = styled('div')`
    position: relative;
    flex: 1 0 32.47%;
    ${props => maxSize(16, props.styleType, 'margin-right', 24)};
    ${props => maxSize(670, props.styleType, 'height')};
    ${props => {
        if(props.styleType === STYLE_TYPE.MOBILE) {
            return `
                margin-right: 0;
                flex: 1 0 100%;
            `
        }
    }}
`;

export const ExCardPicture = styled('div')`
    position: absolute;
    z-index: 2;
    ${props => maxSize(22, props.styleType, 'top', 14)};
    ${props => maxSize(16, props.styleType, 'right')};
    ${props => maxSize(346, props.styleType, 'width', 258)};
    ${props => maxSize(459, props.styleType, 'height', 342)};
    border-radius:  8px;
    overflow: hidden;
    & img {
        height: 100%;
        position: absolute;
        left: 50%;
        transform: translate(-50%)
    }
`;

export const Background = styled('div')`
    position: absolute;
    ${props => maxSize(38, props.styleType, 'top', 26)};
    right: 0;
    ${props => maxSize(346, props.styleType, 'width', 258)};
    ${props => maxSize(459, props.styleType, 'height', 342)};
    border-radius:  8px;
    background-color: ${themeColor};
`;

export const ExKeyWord = styled('div')`
    color: ${themeColor};
    ${props => maxSize(48, props.styleType, 'font-size', 36)};
    ${props => maxSize(48, props.styleType, 'width', 36)};
    ${props => maxSize(58, props.styleType, 'line-height', 50)};
    z-index: 3;
    position: absolute;
`;

export const ExLocation = styled('div')`
    position: absolute;
    color: black;
    ${props => maxSize(14, props.styleType, 'font-size')};
    ${props => maxSize(16, props.styleType, 'right')};
    ${props => maxSize(0, props.styleType, 'top', -4)};
`;

export const ExTitle = styled('div')`
    position: absolute;
    color: black;
    ${props => maxSize(24, props.styleType, 'font-size', 16)};
    ${props => maxSize(530, props.styleType, 'top', 395)};
    ${props => maxSize(36, props.styleType, 'left', 19)};
    max-width: 95%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const ExText = styled('div')`
    position: absolute;
    color: #9A9A9A;
    ${props => maxSize(192, props.styleType, 'width', 268)};
    ${props => textLineClamp(props.styleType === STYLE_TYPE.MOBILE ? 3 : 2)};
    white-space: pre-wrap;
    ${props => maxSize(12, props.styleType, 'font-size', 12)};
    ${props => maxSize(570, props.styleType, 'top', 428)};
    ${props => maxSize(36, props.styleType, 'left', 19)};
`;

export const ExButton = styled('div')`
    position: absolute;
    ${props => {
        if(props.styleType === STYLE_TYPE.MOBILE) {
            return `
                top: ${px2vw(308, 375)};
                z-index: 4;
                background-color: ${themeColor};
                color: white;
                & #line {
                    display: none;
                }
                & #dot{
                    display: none;
                }
                `;
        } else {
            return `
            bottom: 0;
            color: ${themeColor};
            & #line {
                border: 1px solid ${themeColor};
                ${maxSize(9, props.styleType, 'margin-left')};
                ${maxSize(35, props.styleType, 'width')};
            }
            & #dot {
                border-radius: 50%;
                border: 2px solid ${themeColor};
            }
            `;
        }
    }}
    ${props => maxSize(36, props.styleType, 'left', 165)};
    ${props => maxSize(137, props.styleType, 'width', 90)};
    ${props => maxSize(38, props.styleType, 'height', 28)};
    ${props => maxSize(38, props.styleType, 'line-height', 28)};
    ${props => {
        if(props.styleType === STYLE_TYPE.PC) {
            return `
                height: 2.6vw;
                line-height: 2.5vw;
                
                & span {
                    margin-top: 0.2vw;
                    display: inline-block;
                }
            `
        } else if(props.styleType === STYLE_TYPE.BIG_PC) {
            return `
                height: 37.44px;
                line-height: 35.44px;
                margin-top: 2.88px;
                & span {
                    margin-top: 2.88px;
                    display: inline-block;
                }

            `
        }
    }}
    ${props => maxSize(14.4, props.styleType, 'font-size', 12)};
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid ${themeColor};
    border-radius: 21px;
`;

export const ExperienceSwiper = styled('div')`
    ${props => maxSize(1235, props.styleType, 'width', 294)};
    margin: auto;
    ${props => maxSize(67, props.styleType, 'margin-top', 18)};
`;

export const QAWrapper = styled('div')`
    ${props => maxSize(97, props.styleType, 'margin-top', 80)};
`;

export const QAText = styled('pre')`
    color: #9A9A9A;
    margin: auto;
    ${props => maxSize(16, props.styleType, 'font-size', 12)};
    ${props => maxSize(36, props.styleType, 'line-height', 24)};
    ${props => maxSize(32, props.styleType, 'margin-top', 19)};
    ${props => maxSize(856, props.styleType, 'width', 327)};
    white-space: pre-wrap;
`;

export const QAGuide = styled('div')`
    color: #050505;
    margin: auto;
    ${props => maxSize(18, props.styleType, 'font-size', 12)};
    ${props => maxSize(856, props.styleType, 'width', 327)};
    ${props => maxSize(24, props.styleType, 'margin-bottom', 16)};
    ${props => maxSize(14.4, props.styleType, 'margin-top', 16)};
`;

export const Answer = styled('div')`
    margin: auto;
    position: relative;
    background-color:  #F3EBE2;
    ${props => maxSize(18, props.styleType, 'font-size', 12)};
    ${props => maxSize(810, props.styleType, 'width', 295)};    
    ${props => maxSize(23, props.styleType, 'padding', 16)};
`;

export const QuestionButton = styled('div')`
    position: absolute;
    top: 50%;
    ${props => maxSize(24, props.styleType, 'width')};
    ${props => maxSize(24, props.styleType, 'height')};   
    ${props => maxSize(32, props.styleType, 'right', 22)};   
    transform: translate(0,-50%);
    & #row {
        border: 1px solid white;
        height: 0px;
        width: 100%;
        position: absolute;
        top: 50%;
        transform: translate(0,-50%);
    }
    & #column {
        border: 1px solid white;
        width: 0;
        height: 100%;
        position: absolute;
        left: 55%;
        transform: translate(-50%);
    }
    
`;

export const Question = styled('div')`
    color: white;
    ${props => maxSize(18, props.styleType, 'font-size', 12)};
    ${props => maxSize(33, props.styleType, 'margin-left', 16)};
    ${props => maxSize(23, props.styleType, 'padding-top', 18)};
    ${props => maxSize(28, props.styleType, 'padding-bottom', 18)};
    ${props => maxSize(677, props.styleType, 'max-width', 206)};
    & #question_text {
        ${props => maxSize(14.4, props.styleType, 'padding-top', 2.625)};
    }
`;

export const QABlockWrapper = styled('div')`
    margin: auto;
    position: relative;
    ${props => maxSize(856, props.styleType, 'width', 327)};
    ${props => maxSize(4, props.styleType, 'margin-top')};
    background-color: ${themeColor};
`;

export const ContactWrapper = styled('div')`
    ${props => maxSize(73, props.styleType, 'margin-top', 76)};
`;

export const ContactIconWrapper = styled('div')`
    ${props => !props.noMargin && maxSize(42, props.styleType, 'margin-top')};
    ${props => props.thanksMarginTop && maxSize(55, props.styleType, 'margin-top', 36)};
    display: flex;
    justify-content: center;
    align-items: center;
    & :first-child {
        margin-left: 0;
    }
    & img#twitter {
        ${props => maxSize(props.width * 1.2 || 73, props.styleType, 'width', props.width * 1.2|| 36)};
        ${props => maxSize(props.width * 1.2 || 73, props.styleType, 'height', props.width * 1.2 || 36)};
    }
    & img#weibo {
        ${props => maxSize(props.width * 1.13 || 53, props.styleType, 'width', props.width * 1.1|| 33)};
        ${props => maxSize(props.width * 1.13 || 52, props.styleType, 'height', props.width * 1.1 || 33)};
    }
    & img#youtube {
        ${props => maxSize(props.width * 1.13 || 54, props.styleType, 'width', props.width * 1.1|| 33)};
        ${props => maxSize(props.width * 1.13 || 37, props.styleType, 'height', props.width * 0.7 || 22)};
    }
    & img#QQVideo {
        ${props => maxSize(props.width * 1.13 || 50, props.styleType, 'width', props.width * 1.1|| 33)};
        ${props => maxSize(props.width * 1.13 || 50, props.styleType, 'height', props.width * 1.1 || 33)};
    }

    & img {
        ${props => maxSize(props.width || 43, props.styleType, 'width', props.width || 30)};
        ${props => maxSize(props.width || 44, props.styleType, 'height', props.width || 30)};
        ${props => maxSize(props.marginLeft || 64, props.styleType, 'margin-left', props.marginLeft || 20)};
    }
`;

export const Toptips = styled('div')`
    position: fixed;
    top: 0;
    z-index: 100;
    background-color: ${props => props.color};
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    ${props => {
        if(props.styleType === STYLE_TYPE.MOBILE) {
            return `
                width: ${px2vw(375, 375)};
                height: ${px2vw(50, 375)};
            `
        } else {
            return `
                width: 100vw;
                ${maxSize(36, props.styleType, 'height')};
            `
        }
    }}
    & span {
        ${props => maxSize(12, props.styleType, 'font-size', 14)};
        ${props => maxSize(36, props.styleType, 'line-height', 50)};
        ${props => maxSize(33, props.styleType, 'height', 47.25)};
    }
    & #p {
        ${props => maxSize(30, props.styleType, 'width', 12)};
        ${props => maxSize(20, props.styleType, 'margin-left')};
        position: relative;
        height: 100%;
    }
    & #arr {
        ${props => maxSize(8, props.styleType, 'width')};
        ${props => maxSize(8, props.styleType, 'height')};
        border-top: 1px solid white;
        border-left: 1px solid white;
        transform: rotate(135deg);
        position: absolute;
        top: 40%;
        right: 0;

    }
    & #line {
        ${props => maxSize(29, props.styleType, 'width', 12)};
        border-top: 1px solid white;
        transform: translate(0, -50%);
        position: absolute;
        top: 50%;
    }
    & #close {
        position: absolute;
        top: 50%;
        transform: translate(0, -50%);
        ${props => maxSize(16, props.styleType, 'width', 16)};
        ${props => maxSize(15, props.styleType, 'height', 15)};
        ${props => maxSize(24, props.styleType, 'right', 24)};
        & img {
            width: 100%;
            height: 100%;
        }
    }
    & #top {
        position: absolute;
        top: 46%;
        transform: translate(0, -50%);
        ${props => {
            if(props.styleType !== STYLE_TYPE.MOBILE) {
                return `left: ${px2vw(770)};`;
            } else {
                return `left: ${px2vw(240, 375)};`
            }
        }}
        ${props => maxSize(30, props.styleType, 'width', 12)};
        ${props => maxSize(10, props.styleType, 'height', 10)};
    }
    & #detail {
        position: absolute;
        top: 45%;
        transform: translate(0, -50%);
        ${props => maxSize(800, props.styleType, 'left', 300)};
        ${props => maxSize(30, props.styleType, 'width', 12)};
        ${props => maxSize(10, props.styleType, 'height', 10)};
    }
    & #detail_link {
        position: absolute;
        top: 50%;
        transform: translate(0, -50%);
        ${props => maxSize(800, props.styleType, 'left', 315)};
        ${props => maxSize(30, props.styleType, 'width', 12)};
        ${props => maxSize(10, props.styleType, 'height', 10)};
    }
`;

export const SeeMore = styled('div')`
    margin-top: ${px2vw(16, 375)};
    font-size: ${px2vw(10, 375)};
    color: #BCB4A7;
    display:flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    & #arrow {
        width: ${px2vw(11, 375)};
        height: ${px2vw(11, 375)};
        border-left: 1px solid #8F5F07;
        border-bottom: 1px solid #8F5F07;
        transform: rotate(-40deg) skew(10deg);
    }
`;

export const RightTips = styled('div')`
    font-size: ${px2vw(10, 375)};
    position: absolute;
    top: ${px2vw(295, 375)};
    right: ${px2vw(24, 375)};
    color: #9A9A9A;
    display: flex;
    align-items: center;
    ${props => getArrow(props.styleType)};
`;

const getArrow = (styleType) => {
    return `
    & #w {
        height: ${px2vw(12, 375)};
        display: inline-block;
        position: relative;
        overflow: hidden;
        width: ${px2vw(23, 375)};
    }
    & #arr {
        ${maxSize(23, styleType, 'width', 10)};
        ${maxSize(23, styleType, 'height', 10)};
        border-top: 1px solid #8F7951;
        border-left: 1px solid #8F7951;
        position: absolute;
        top: 50%;
        transform: rotate(135deg) translate(0, 70%); 
        right: 0;
    }
    & #line {
        ${maxSize(40, styleType, 'width', 13)};
        border-top: 1px solid #8F7951;
        position: absolute;
        top: 50%;
        right: ${px2vw(4, 375)};
        transform: translate(0, -50%);
    }`
};

export const CardTopTips = styled('div')`
    position: absolute;
    top: 0;
    left: 0;
    background-color: ${themeColor};
    color: white;
    text-align: center;
    ${props => maxSize(480, props.styleType, 'width', 375)};
    ${props => maxSize(34, props.styleType, 'height', 34)};
    ${props => maxSize(34, props.styleType, 'line-height', 34)};
    ${props => maxSize(12, props.styleType, 'font-size', 10)};

`;

export const YelloArrow = styled('div')`
    position: absolute;
    left: 50%;
    transform: translate(-50%);
    ${props => maxSize(0, props.styleType, 'top', 416)};
    ${props => maxSize(0, props.styleType, 'width', 18)};
    ${props => maxSize(0, props.styleType, 'height', 13)};
    & img {
        width: 100%;
        height: 100%;
    }
`;